export default function Logo({ dark = true, compact = false }: { dark?: boolean; compact?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
        <i className="ri-pulse-line text-lg" />
      </span>
      {!compact && (
        <span
          className={`font-heading text-xl font-semibold ${
            dark ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          StatFlow
        </span>
      )}
    </span>
  );
}
